import { Empty, Typography } from 'antd';

const { Title } = Typography;

/** Every routed page that doesn't have real content yet in this task, so
 * the Sider menu is fully navigable from Task 8a onward. */
export function PagePlaceholder({ title }: { title: string }) {
  return (
    <div>
      <Title level={3}>{title}</Title>
      <Empty description={`Pagina ${title} — în construcție`} />
    </div>
  );
}
